import { render, staticRenderFns } from "./SectionDashboard.vue?vue&type=template&id=61a19dd6"
import script from "./SectionDashboard.vue?vue&type=script&lang=js"
export * from "./SectionDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports